<template>
  <div class="retrievePsd">
    <div class="title">找回密码</div>
    <div class="retrievePsdForm">
      <div class="phoneNumber">
        <input
          type="text"
          :value="loginForm.phone"
          placeholder="请输入手机号"
          @input="changeForm('phone', $event.target.value)"
        />
      </div>
      <div class="verifyCode">
        <input
          type="text"
          :value="loginForm.code"
          placeholder="请输入验证码"
          @input="changeForm('code', $event.target.value)"
        />
        <span class="line"></span>
        <button
          class="forgetPsd"
          @click="getSMS"
          :disabled="state.codeDisabled"
        >
          {{ state.codeMsg }}
        </button>
      </div>
      <div class="newPsd">
        <input
          type="password"
          :value="loginForm.password"
          placeholder="请输入新密码"
          @input="changeForm('password', $event.target.value)"
        />
      </div>
      <a-button
        class="loginBtn"
        type="primary"
        :loading="btnState"
        :disabled="btnState"
        @click="revisePsd"
      >登 录
      </a-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "RetrievePsd", // 找回密码
  props: {
    loginForm: {
      type: Object,
      default: () => {
      }
    },
    btnState: {
      type: Boolean,
      default: false
    },
    // 状态
    state: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    // 获取验证码
    getSMS() {
      const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (myreg.test(this.loginForm.phone)) {
        this.$emit("getSMS");
      } else {
        this.$message.error("请输入正确格式的手机号");
      }
    },
    revisePsd() {
      if (this.loginForm.phone === "") {
        this.$message.error("请输入手机号");
      } else if (this.loginForm.code === "") {
        this.$message.error("请输入验证码");
      } else if (this.loginForm.password === "") {
        this.$message.error("请输入新密码");
      } else {
        this.$emit("revisePsd");
      }
    },
    // 修改表单数据
    changeForm(name, val) {
      console.log(name, "name", val, "val");
      this.$emit("changeForm", name, val);
    }
  }
};
</script>

<style lang="less" scoped>
.retrievePsd {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 680px;
  height: 538px;
  background: #ffffff;
  box-shadow: 0px 6px 50px 12px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  box-sizing: border-box;
  // filter: blur(50px);

  .title {
    margin-top: 70px;
    width: 360px;
    font-size: 22px;
    color: #333333;
  }

  input,
  .loginBtn {
    padding-left: 20px;
    width: 360px;
    height: 60px;
    line-height: 60px;
    background: #f6f6f6;
    border-radius: 30px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .phoneNumber {
    margin-top: 38px;
  }

  .verifyCode {
    position: relative;
    margin: 24px 0;

    .line {
      position: absolute;
      top: 50%;
      right: 110px;
      width: 1px;
      height: 25px;
      background-color: #cbcbcb;
      transform: translate(0, -50%);
    }

    .forgetPsd {
      position: absolute;
      top: 50%;
      right: 20px;
      font-size: 14px;
      color: #ff6f5b;
      transform: translate(0, -50%);
      cursor: pointer;
    }
  }

  .loginBtn {
    margin-top: 50px;
    font-size: 26px;
    color: #ffffff;
    background: #ff6f5b;
    border-color: #ffffff;
  }

  input:focus {
    border: 2px solid #ff6f5b;
  }
}
</style>
